module.exports = __webpack_public_path__ + "img/hand-index.3decabc9.svg";